//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "SysAnnouncementModal",
  components: {},
  data: function data() {
    return {
      title: "通知消息",
      record: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      visible: false,
      loading: false,
      bodyStyle: {
        padding: "0",
        height: window.innerHeight * 0.8 + "px",
        "overflow-y": "auto"
      }
    };
  },
  created: function created() {},
  methods: {
    detail: function detail(record) {
      this.visible = true;
      this.record = record;
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    }
  }
};